module.exports = __webpack_public_path__ + "media/images/arrow-white-right-b2c52962.png";